import _ from 'underscore';
import type { AjaxData, DomainList } from '../types';

/**
 * UrlErrorMapper - Maps ajax errors from known invalid domains as user errors
 */
export class UrlErrorMapper {
 domains: DomainList;
 /**
  * @param {object} domains - known invalid domains
  */
 constructor(domains: DomainList) {
   this.domains = domains || [];
 }

 /**
  * Checks if the url is of a known invalid domain
  * @param {object} ajaxData - data related to the current ajax call
  * @returns {bool} - if the url maps to a known invalid domain or not
  */
 check(ajaxData: AjaxData) {
   const ajaxUrlString = ajaxData.url;

   return _.isString(ajaxUrlString) &&
     _.any(this.domains, domain => ajaxUrlString.toUpperCase().indexOf(domain.toUpperCase()) >= 0);
 }
}
